/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './NotFound.css';

class NotFound extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div className={s.root}>
        <div className={s.container}>
          <h1>{this.props.title}</h1>
          <p>
            Wow, you're lost. Totally on the wrong track. It's ok to admit
            that. Don't worry though - if there's something you're looking for,
            and you work hard, I'm sure we'll find your way.
            <br /><br />
            If you're bored, try thinking about the Colatz conjecture.
          </p>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(NotFound);



// WEBPACK FOOTER //
// src/routes/notFound/NotFound.js